import { TicketStatus } from 'flow/types/Tickets';

export const STATUS_LABEL_KEYS: Record<TicketStatus, string> = Object.freeze({
    open: 'pbx.open',
    closed: 'tickets.closed',
});

export const STATUS_KEYS_IN_ORDER: TicketStatus[] = ['open', 'closed'];
